import { defineComponent } from "vue";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";
import ExampleTestModal from "@/components/Modals/ExampleTestModal/ExampleTestModal.vue";
import UploadPicture from "@/components/RegisterTest/UploadPicture/UploadPicture.vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { mapWritableState } from "pinia";
import AlertBox from "@/components/AlertBox/AlertBox.vue";
import ThemesHelper from "@/helpers/ThemesHelper";

export default defineComponent({
  components: {
    FloatingCard,
    ExampleTestModal,
    UploadPicture,
    AlertBox,
  },
  data() {
    return {
      registerTestStore: useRegisterTestStore(),
      hasError: false,
      imagePath: null,
      StepContent: ThemesHelper.getThemeParams("testStepFiveContents"),
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
  },
  methods: {
    imageChanged(newImage: any) {
      this.registerTestStore.testImage = newImage;
      this.registerTestStore.canJumpNext = newImage != "";
      this.hasError = false;
    },
    showInfoModal() {
      const el: any = this.$refs["info-modal"];
      el.toggleModal(true);
    },
    isValidStep(): boolean {
      return this.registerTestStore.testImage != "";
    },
    errorValidation() {
      this.hasError = true;
      return false;
    },
    isIOSDevice() {
      const platform = navigator.userAgent.toLowerCase();
      return platform.includes("iphone") || platform.includes("ios");
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case "setNextDismissAnimation":
            baseModal.setNextDismissAnimation();
            break;
          case "setNextShowAnimation":
            baseModal.setNextShowAnimation();
            break;
          case "setPreviousDismissAnimation":
            baseModal.setPreviousDismissAnimation();
            break;
          case "setPreviousShowAnimation":
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
});
